import apiService from './api';

export interface Unit {
  id: number;
  name: string;
  abbreviation: string;
  isActive: boolean;
}

export class UnitService {
  async getAllUnits(): Promise<Unit[]> {
    return apiService.get<Unit[]>('/api/units');
  }

  async getUnitById(id: number): Promise<Unit> {
    return apiService.get<Unit>(`/api/units/${id}`);
  }

  async createUnit(unitData: Partial<Unit>): Promise<Unit> {
    return apiService.post<Unit>('/api/units', unitData);
  }

  async updateUnit(id: number, unitData: Partial<Unit>): Promise<Unit> {
    return apiService.put<Unit>(`/api/units/${id}`, unitData);
  }

  async deleteUnit(id: number): Promise<void> {
    await apiService.delete(`/api/units/${id}`);
  }

  async activateUnit(id: number): Promise<Unit> {
    return apiService.put<Unit>(`/api/units/${id}`, { isActive: true });
  }

  async deactivateUnit(id: number): Promise<Unit> {
    return apiService.put<Unit>(`/api/units/${id}`, { isActive: false });
  }
}

export const unitService = new UnitService();
export default unitService;
